import { render, staticRenderFns } from "./FormVmSettings.vue?vue&type=template&id=bdea1952&"
import script from "./FormVmSettings.vue?vue&type=script&lang=js&"
export * from "./FormVmSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports